<template>
	<div class="col-sm-2">
		<!--<button type="button" class="btn btn-black btn-sm visible-xs collapsed" id="side-menu" data-toggle="collapse" data-target="#menu-collapse2" aria-expanded="false">Menu
		</button> -->
		<button class="btn btn-black btn-lg visible-xs collapsed" id="side-menu" data-toggle="collapse" data-target="#menu-collapse2" aria-expanded="false">
		Menú de cuenta
		</button>
		<aside class="sidebar">
			<div class="collapse navbar-collapse" id="menu-collapse2">
		        <ul>
			        <li role="presentation" v-if="render_user.token">
			            <a class="sidebar-link" v-link="{ path: '/bienvenido' }">Mi cuenta</a>
			        </li>
			         <li role="presentation" v-if="render_user.token">
			            <a class="sidebar-link" v-link="{ path: '/configuracion'}">Configuración</a>
			        </li>
			        <li role="presentation" v-if="render_user.token">
			            <a class="sidebar-link" v-link="{ path: '/cambiar-contrasena'}">Cambiar contraseña</a>
			        </li>
			         <li role="presentation">
			            <a class="sidebar-link" v-link="{ path: '/carrito-de-compra' }">Mi carrito</a>
			        </li>
			        <li role="presentation" v-if="render_user.token">
			          <a class="sidebar-link" v-link="{ path: '/compras-previas' }">Compras anteriores</a>
			        </li>
			        <li role="presentation" v-if="render_user.token">
			          <a class="sidebar-link" v-link="{ path: '/favoritos?page=1' }">Favoritos</a>
			        </li>
			        <li role="presentation" v-if="render_user.token">
			          <a class="sidebar-link" v-link="{ path: '/mis-direcciones' }">Mis Direcciones</a>
			        </li>
		        </ul>
			</div><!-- /.navbar-collapse -->
		</aside>
	</div>
</template>

<script>
export default {
	vuex: {
		getters: {
			user: state => state.current_user
		}
	},

	computed: {
		render_user() {
			return this.user
		}
	}
}
</script>

<style scoped>
	.col-sm-2{
		padding-top: 0;
	}
	
	.v-link-active {
		font-weight: 900;
	}
</style>


// WEBPACK FOOTER //
// Sidebar.vue?5305383f